import moment from "moment";
import { boolean, object, string } from "yup";

export const subscriberValidations = object({
  move_in_date: string()
    .required("Move in date is required")
    .test(
      "move-in-date",
      "Tenant must be at least 18 years old on move-in date",
      function (value) {
        if (!this.parent.dob && !this.parent.ssn) return true;
        if (!this.parent.dob && this.parent.ssn) return true;
        const dobValidDate = moment(this.parent.dob).add(18, "years");
        return moment(value).isSameOrAfter(dobValidDate);
      }
    )
    .test(
      "move-in-date-in-past",
      "Move in date must be in the past",
      function (value) {
        return moment(value).isSameOrBefore(moment());
      }
    ),
  lease_end_date: string()
    .test(
      "optional-if-month-to-month",
      "Lease end date is required",
      function (value) {
        return this.parent.lease_month_to_month || value;
      }
    )
    .test(
      "lease-1-month",
      "Lease must be at least one calendar month long.",
      function (value) {
        const firstValidDate = moment(this.parent.move_in_date).add(1, "month");
        return (
          this.parent.lease_month_to_month ||
          moment(value).isSameOrAfter(firstValidDate)
        );
      }
    )
    .test(
      "ongoing-lease",
      "Lease end date must be in the the future",
      function (value) {
        return this.parent.lease_month_to_month || !value
          ? true
          : moment(value).isSameOrAfter(moment().subtract(1, "day"));
      }
    ),
  lease_month_to_month: boolean(),
  monthly_rent_amount: string().required("Rent amount is required")
});
